module.exports = __webpack_public_path__ + "img/about_us_4.48770965.png";